import React from 'react';
import { Menu, MenuItemLink, usePermissions } from 'react-admin';
import SmsIcon from '@mui/icons-material/Sms';
import Role from 'constants/role';
import { rolesMatch } from 'utils/user';

function CustomMenu(props) {
  const { permissions: roles } = usePermissions();


  return (
    <Menu {...props}>
      <Menu.ResourceItems />
      {rolesMatch({ roles, role: Role.USER_VIEW }) && (
        <MenuItemLink to="/send-sms" primaryText="Send SMS" leftIcon={<SmsIcon />} />
      )}
    </Menu>
  );
}

export default CustomMenu;
